<!-- ================================================================
     SEHYOG ACADEMY — GCSE FOCUSED CLASSES PAGE
     Angular 7 | Brand: #06253A / #0B4F6C / #01BAEF / #F5A623
     All classes prefixed gc-  |  Matches 11+ page design system
================================================================ -->
<div class="gc-page">

  <!-- ══════════════════════════════════════════════════════════════
       HERO
  ══════════════════════════════════════════════════════════════ -->
  <section class="gc-hero">
    <div class="gc-hero-bg"></div>
    <div class="gc-hero-grid"></div>
    <div class="gc-orb gc-orb-a"></div>
    <div class="gc-orb gc-orb-b"></div>
    <div class="gc-orb gc-orb-c"></div>

    <div class="gc-container">
      <div class="gc-hero-inner">

        <!-- Left: text -->
        <div class="gc-hero-left">
          <div class="gc-hero-badge">
            <span class="gc-badge-pulse"></span>
            GCSE Exam Specialists
          </div>

          <h1 class="gc-hero-h1">
            <span class="gc-h1-blue">GCSE</span> Focused Classes<br/>
            <em>&amp; Exam Preparation</em>
          </h1>

          <div class="gc-boards-row">
            <span class="gc-board-chip">AQA</span>
            <span class="gc-board-chip">OCR</span>
            <span class="gc-board-chip gc-chip-gold">EDEXCEL</span>
            <span class="gc-board-chip">EDUQAS</span>
          </div>

          <div class="gc-mode-row">
            <span class="gc-mode-item">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="2" y="3" width="20" height="14" rx="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
              Online 1-2-1
            </span>
            <span class="gc-mode-sep">·</span>
            <span class="gc-mode-item">
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/></svg>
              Group Classes
            </span>
          </div>

          <p class="gc-hero-lead">
            Expert-led, structured GCSE preparation from Year 7 to Year 11 — personalised study plans,
            consistent assessment and board-specific guidance across all major exam boards.
          </p>

          <div class="gc-hero-btns">
            <button class="gc-btn-primary" (click)="bookFreeDemo()">
              Book a Free Demo
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            </button>
            <button class="gc-btn-ghost" routerLink="/gcse-mock-test">Browse Mock Tests</button>
          </div>

          <div class="gc-hero-stats">
            <div class="gc-hstat">
              <span class="gc-hstat-num">10K+</span>
              <span class="gc-hstat-lbl">GCSE Students</span>
            </div>
            <div class="gc-hstat-line"></div>
            <div class="gc-hstat">
              <span class="gc-hstat-num">4</span>
              <span class="gc-hstat-lbl">Exam Boards</span>
            </div>
            <div class="gc-hstat-line"></div>
            <div class="gc-hstat">
              <span class="gc-hstat-num">7</span>
              <span class="gc-hstat-lbl">Subjects Covered</span>
            </div>
          </div>
        </div>

        <!-- Right: hero image -->
        <div class="gc-hero-right">
          <div class="gc-hero-img-wrap">
            <img src="assets/images/Gcseimg1.png" alt="GCSE Students in class"/>
            <div class="gc-hero-img-ov"></div>
            <div class="gc-hero-img-label">
              <div class="gc-hil-icon">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 10v6M2 10l10-5 10 5-10 5z"/><path d="M6 12v5c0 1.7 2.7 3 6 3s6-1.3 6-3v-5"/></svg>
              </div>
              <div>
                <div class="gc-hil-num">Grades 4–9 Targeted</div>
                <div class="gc-hil-sub">Structured board-specific prep</div>
              </div>
            </div>
          </div>
          <!-- Floating chips -->
          <div class="gc-hfc gc-hfc-1">
            <div class="gc-hfc-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="8" y="2" width="8" height="4" rx="1"/><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="9" y1="10" x2="15" y2="10"/><line x1="9" y1="14" x2="15" y2="14"/></svg>
            </div>
            <div>
              <div class="gc-hfc-lbl">All Major</div>
              <div class="gc-hfc-val">Exam Boards</div>
            </div>
          </div>
          <div class="gc-hfc gc-hfc-2">
            <div class="gc-hfc-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
            </div>
            <div>
              <div class="gc-hfc-lbl">Year 7</div>
              <div class="gc-hfc-val">to Year 11</div>
            </div>
          </div>
        </div>

      </div>
    </div>

    <svg class="gc-hero-wave" viewBox="0 0 1440 64" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
      <path d="M0 64L60 54C120 44 240 24 360 18C480 12 600 24 720 30C840 36 960 40 1080 36C1200 32 1320 16 1380 8L1440 0V64H0Z" fill="#F4F8FA"/>
    </svg>
  </section>

  <!-- ══════════════════════════════════════════════════════════════
       TESTIMONIALS
  ══════════════════════════════════════════════════════════════ -->
  <section class="gc-section gc-bg-white" id="gc-testi">
    <div class="gc-container">

      <div class="gc-sec-header gc-reveal">
        <div class="gc-pill">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg>
          Parent Stories
        </div>
        <h2 class="gc-sec-title">Happy Parents &amp; Successful Students at SEHYOG</h2>
        <p class="gc-sec-lead">Real stories from families who chose Sehyog Academy for their child's GCSE journey.</p>
      </div>

      <div class="gc-testi-layout gc-reveal">

        <!-- Featured video left -->
        <div class="gc-testi-featured">
          <div class="gc-testi-video-wrap">
            <div class="gc-testi-badge">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polygon points="5 3 19 12 5 21 5 3"/></svg>
              Featured Story
            </div>
            <div class="gc-video-ratio">
              <iframe src="https://www.youtube.com/embed/fVU0xDgiclA" title="Success Story 01" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
            </div>
          </div>
          <div class="gc-testi-foot">
            <div class="gc-testi-stars">★★★★★</div>
            <p class="gc-testi-quote">"Sehyog's structured approach and board-specific guidance helped my son achieve Grade 8 in Maths. Absolutely outstanding!"</p>
            <div class="gc-testi-author">
              <div class="gc-author-av">P</div>
              <div>
                <div class="gc-author-name">Happy Parent</div>
                <div class="gc-author-sub">GCSE Grade 8 Success</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Right: two mini + stats -->
        <div class="gc-testi-right">

          <div class="gc-testi-mini gc-reveal gc-d1">
            <div class="gc-testi-mini-vid">
              <div class="gc-video-ratio">
                <iframe src="https://www.youtube.com/embed/bSFVlZahTac?si=ObniW_umo9GaPPzt" title="Success Story 02" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              </div>
            </div>
            <div class="gc-testi-mini-info">
              <div class="gc-mini-stars">★★★★★</div>
              <p class="gc-mini-text">"The weekly doubt-clearing sessions and personalised feedback made all the difference."</p>
              <span class="gc-mini-tag">Success Story</span>
            </div>
          </div>

          <div class="gc-testi-mini gc-reveal gc-d2">
            <div class="gc-testi-mini-vid">
              <div class="gc-video-ratio">
                <iframe src="https://www.youtube.com/embed/n1OKFV6Wa68?si=u-3smcQJEFD7XJD0" title="Success Story 03" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
              </div>
            </div>
            <div class="gc-testi-mini-info">
              <div class="gc-mini-stars">★★★★★</div>
              <p class="gc-mini-text">"The mock tests and RAR reports helped us understand exactly where to focus each week."</p>
              <span class="gc-mini-tag">Success Story</span>
            </div>
          </div>

          <div class="gc-testi-stats gc-reveal gc-d3">
            <div class="gc-tstat">
              <span class="gc-tstat-num">10K+</span>
              <span class="gc-tstat-lbl">Students Placed</span>
            </div>
            <div class="gc-tstat">
              <span class="gc-tstat-num">98%</span>
              <span class="gc-tstat-lbl">Pass Rate</span>
            </div>
            <div class="gc-tstat">
              <span class="gc-tstat-num">5★</span>
              <span class="gc-tstat-lbl">Avg Rating</span>
            </div>
          </div>

          <div class="gc-reveal gc-d3">
            <button class="gc-btn-primary gc-full-btn" routerLink="/testimonials">
              View All Stories
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            </button>
          </div>

        </div>
      </div>
    </div>
  </section>

  <!-- ══════════════════════════════════════════════════════════════
       STRIP BANNER
  ══════════════════════════════════════════════════════════════ -->
  <div class="gc-strip gc-reveal">
    <div class="gc-container gc-strip-inner">
      <div class="gc-strip-left">
        <span class="gc-strip-num">10K+</span>
        <span class="gc-strip-text">Successful GCSE Students<br/><strong>at top UK schools</strong></span>
      </div>
      <button class="gc-btn-strip" (click)="bookFreeDemo()">Book a Free Demo</button>
    </div>
  </div>

  <!-- ══════════════════════════════════════════════════════════════
       SEHYOG STRATEGY — FLIP CARDS
  ══════════════════════════════════════════════════════════════ -->
  <section class="gc-section gc-bg-light" id="gc-strategy">
    <div class="gc-container">

      <div class="gc-sec-header gc-reveal">
        <div class="gc-pill">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>
          Our Approach
        </div>
        <h2 class="gc-sec-title">SEHYOG Strategy</h2>
        <p class="gc-sec-lead">Comprehensive Offerings Under One Umbrella — hover each card to explore</p>
      </div>

      <div class="gc-flip-grid gc-reveal">

        <div class="gc-flip-card">
          <div class="gc-flip-inner">
            <div class="gc-flip-front">
              <img src="assets/images/strategy1.png" alt="Targeted Study Notes"/>
              <div class="gc-flip-title">Targeted Study Notes</div>
            </div>
            <div class="gc-flip-back">
              <div class="gc-flip-back-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>
              </div>
              <h3>Targeted Study Notes</h3>
              <ul>
                <li>Board-wise experienced teachers</li>
                <li>Activate prior learning</li>
                <li>High depth of concepts</li>
                <li>Quick lecture summary videos</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="gc-flip-card">
          <div class="gc-flip-inner">
            <div class="gc-flip-front">
              <img src="assets/images/startegy2.png" alt="Interactive Lectures"/>
              <div class="gc-flip-title">Interactive Lectures</div>
            </div>
            <div class="gc-flip-back">
              <div class="gc-flip-back-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="23 7 16 12 23 17 23 7"/><rect x="1" y="5" width="15" height="14" rx="2"/></svg>
              </div>
              <h3>Interactive Lectures</h3>
              <ul>
                <li>Live doubt-solving sessions</li>
                <li>Engaging explanations</li>
                <li>Practice-led delivery</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="gc-flip-card">
          <div class="gc-flip-inner">
            <div class="gc-flip-front">
              <img src="assets/images/stategy3.png" alt="All Round Learning"/>
              <div class="gc-flip-title">All Round Learning</div>
            </div>
            <div class="gc-flip-back">
              <div class="gc-flip-back-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><path d="M12 8v4l3 3"/></svg>
              </div>
              <h3>All Round Learning</h3>
              <ul>
                <li>Concepts + application</li>
                <li>Balanced topic coverage</li>
                <li>Individualised support</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="gc-flip-card">
          <div class="gc-flip-inner">
            <div class="gc-flip-front">
              <img src="assets/images/strategy4.png" alt="Consistent Assessment"/>
              <div class="gc-flip-title">Consistent Assessment</div>
            </div>
            <div class="gc-flip-back">
              <div class="gc-flip-back-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><rect x="8" y="2" width="8" height="4" rx="1"/><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="9" y1="10" x2="15" y2="10"/><line x1="9" y1="14" x2="15" y2="14"/></svg>
              </div>
              <h3>Consistent Assessment</h3>
              <ul>
                <li>Regular class tests</li>
                <li>Progress tracking</li>
                <li>Unit &amp; topic tests</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="gc-flip-card">
          <div class="gc-flip-inner">
            <div class="gc-flip-front">
              <img src="assets/images/startegy5.png" alt="Error Log & Feedback"/>
              <div class="gc-flip-title">Error Log &amp; Feedback</div>
            </div>
            <div class="gc-flip-back">
              <div class="gc-flip-back-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/></svg>
              </div>
              <h3>Error Log &amp; Feedback</h3>
              <ul>
                <li>Personalised feedback</li>
                <li>Actionable insights</li>
                <li>Parent-Teacher Meetings</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="gc-flip-card">
          <div class="gc-flip-inner">
            <div class="gc-flip-front">
              <img src="assets/images/startegy6.png" alt="Past Papers & Mocks"/>
              <div class="gc-flip-title">Past Papers &amp; Full Mocks</div>
            </div>
            <div class="gc-flip-back">
              <div class="gc-flip-back-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/></svg>
              </div>
              <h3>Past Papers &amp; Mocks</h3>
              <ul>
                <li>Exam-style practice</li>
                <li>Time management skills</li>
                <li>Board-specific papers</li>
              </ul>
            </div>
          </div>
        </div>

        <div class="gc-flip-card">
          <div class="gc-flip-inner">
            <div class="gc-flip-front">
              <img src="assets/images/startegy6.png" alt="Analytics Dashboard"/>
              <div class="gc-flip-title">Analytics Dashboard</div>
            </div>
            <div class="gc-flip-back">
              <div class="gc-flip-back-icon">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/></svg>
              </div>
              <h3>Analytics Dashboard</h3>
              <ul>
                <li>Strengths &amp; gaps identified</li>
                <li>Smart recommendations</li>
                <li>Progress over time</li>
              </ul>
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ══════════════════════════════════════════════════════════════
       COURSES & SUBJECTS
  ══════════════════════════════════════════════════════════════ -->
  <section class="gc-section gc-bg-white" id="gc-subjects">
    <div class="gc-container">

      <div class="gc-sec-header gc-reveal">
        <div class="gc-pill">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg>
          What We Cover
        </div>
        <h2 class="gc-sec-title">Courses &amp; Subjects We Offer</h2>
        <p class="gc-sec-lead">Board-specific preparation across all core GCSE subjects.</p>
      </div>

      <!-- Subject chips -->
      <div class="gc-subjects-row gc-reveal">
        <div class="gc-subj-chip">
          <div class="gc-subj-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/></svg></div>
          Mathematics
        </div>
        <div class="gc-subj-chip">
          <div class="gc-subj-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/><path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/></svg></div>
          English
        </div>
        <div class="gc-subj-chip">
          <div class="gc-subj-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v8m0 0H3m6 0h12M3 11v8a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-8"/></svg></div>
          Physics
        </div>
        <div class="gc-subj-chip">
          <div class="gc-subj-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="8" r="6"/><path d="M15.477 12.89L17 22l-5-3-5 3 1.523-9.11"/></svg></div>
          Chemistry
        </div>
        <div class="gc-subj-chip">
          <div class="gc-subj-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M8 3H5a2 2 0 0 0-2 2v3m18 0V5a2 2 0 0 0-2-2h-3m0 18h3a2 2 0 0 0 2-2v-3M3 16v3a2 2 0 0 0 2 2h3"/></svg></div>
          Biology
        </div>
        <div class="gc-subj-chip">
          <div class="gc-subj-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/></svg></div>
          German
        </div>
        <div class="gc-subj-chip">
          <div class="gc-subj-icon"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z"/></svg></div>
          French
        </div>
      </div>

      <!-- Course cards -->
      <div class="gc-courses-grid">

        <div class="gc-course-card gc-reveal">
          <div class="gc-course-hdr gc-hdr-primary">
            <div class="gc-course-hdr-top">
              <span class="gc-course-badge">Most Popular</span>
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><polygon points="13 2 3 14 12 14 11 22 21 10 12 10 13 2"/></svg>
            </div>
            <h3>Fast Forward Course <span class="gc-hdr-icon">▶▶</span></h3>
            <p>Fast forward Course for Year 11, Year 10, Year 9, Year 8 &amp; Year 7 Students</p>
          </div>
          <div class="gc-course-body">
            <div class="gc-info-row">
              <span class="gc-info-lbl">Recommended For</span>
              <span class="gc-info-val">Year 11, 10, 9, 8 &amp; 7</span>
            </div>
            <div class="gc-info-row">
              <span class="gc-info-lbl">Duration</span>
              <span class="gc-info-val">35 – 45 Weeks</span>
            </div>
            <div class="gc-info-row">
              <span class="gc-info-lbl">Sessions</span>
              <span class="gc-info-val">175 – 230 Sessions</span>
            </div>
            <div class="gc-info-row">
              <span class="gc-info-lbl">Fee Schedule</span>
              <span class="gc-info-val">One-Time / Monthly Payment</span>
            </div>
            <div class="gc-provided-title">What's Included</div>
            <ul class="gc-feat-list">
              <li>Course Structure &amp; Pre-Lecture Material (PLM)</li>
              <li>Daily / Weekly Home &amp; Class Work</li>
              <li>Face-to-Face Unit &amp; Topic Tests</li>
              <li>Fortnightly Revision Tests</li>
              <li>Weekly Doubt Clearing Sessions</li>
            </ul>
            <button class="gc-btn-primary gc-course-btn" (click)="bookFreeDemo()">Book a Free Demo</button>
          </div>
        </div>

        <div class="gc-course-card gc-reveal gc-d2">
          <div class="gc-course-hdr gc-hdr-dark">
            <div class="gc-course-hdr-top">
              <span class="gc-course-badge gc-badge-gold">Flexible</span>
              <svg width="30" height="30" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M12 2L2 7l10 5 10-5-10-5z"/><path d="M2 17l10 5 10-5"/><path d="M2 12l10 5 10-5"/></svg>
            </div>
            <h3>Regular Course <span class="gc-payg">Pay As You Go</span></h3>
            <p>Basics to best level GCSE preparation for Year 7 to Year 11 Students</p>
          </div>
          <div class="gc-course-body">
            <div class="gc-info-row">
              <span class="gc-info-lbl">Recommended For</span>
              <span class="gc-info-val">Year 7 to Year 11</span>
            </div>
            <div class="gc-info-row">
              <span class="gc-info-lbl">Duration</span>
              <span class="gc-info-val">Flexible</span>
            </div>
            <div class="gc-info-row">
              <span class="gc-info-lbl">Sessions</span>
              <span class="gc-info-val">Flexible</span>
            </div>
            <div class="gc-info-row">
              <span class="gc-info-lbl">Fee Schedule</span>
              <span class="gc-info-val">Monthly Payment</span>
            </div>
            <div class="gc-provided-title">What's Included</div>
            <ul class="gc-feat-list">
              <li>Course Structure &amp; Pre-Lecture Material (PLM)</li>
              <li>Daily / Weekly Home &amp; Class Work</li>
              <li>Face-to-Face Unit &amp; Topic Tests</li>
              <li>Revision Tests</li>
              <li>Doubt Clearing Sessions</li>
            </ul>
            <button class="gc-btn-gold gc-course-btn" (click)="bookFreeDemo()">Book a Free Demo</button>
          </div>
        </div>

      </div>
    </div>
  </section>

  <!-- ══════════════════════════════════════════════════════════════
       RESULT ANALYSIS REPORT
  ══════════════════════════════════════════════════════════════ -->
  <section class="gc-rar-section" id="gc-rar">
    <div class="gc-container">

      <div class="gc-sec-header gc-reveal">
        <div class="gc-pill">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="23 6 13.5 15.5 8.5 10.5 1 18"/><polyline points="17 6 23 6 23 12"/></svg>
          Performance Tracking
        </div>
        <h2 class="gc-sec-title">Result Analysis Report</h2>
        <p class="gc-sec-lead">Detailed insights into every aspect of your child's GCSE test performance.</p>
      </div>

      <div class="gc-rar-card gc-reveal">
        <div class="gc-rar-card-bg"></div>

        <div class="gc-rar-left">
          <!-- Chips -->
          <div class="gc-rar-chips">
            <div class="gc-rar-chip"><span class="gc-rar-chip-num">3</span><span class="gc-rar-chip-lbl">Report Dimensions</span></div>
            <div class="gc-rar-chip"><span class="gc-rar-chip-num">100%</span><span class="gc-rar-chip-lbl">Subject Coverage</span></div>
            <div class="gc-rar-chip"><span class="gc-rar-chip-num">Live</span><span class="gc-rar-chip-lbl">After Every Mock</span></div>
          </div>

          <!-- Feature items -->
          <div class="gc-rar-items">
            <div class="gc-rar-item">
              <div class="gc-rar-icon gc-rar-icon-p">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><line x1="18" y1="20" x2="18" y2="10"/><line x1="12" y1="20" x2="12" y2="4"/><line x1="6" y1="20" x2="6" y2="14"/><line x1="2" y1="20" x2="22" y2="20"/></svg>
              </div>
              <div class="gc-rar-body">
                <h4>Subject-wise Marks Analysis</h4>
                <p>Complete breakdown per subject — pinpoint where your child is strong and where to focus next.</p>
              </div>
              <span class="gc-rar-num">01</span>
            </div>
            <div class="gc-rar-item">
              <div class="gc-rar-icon gc-rar-icon-s">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="10"/><circle cx="12" cy="12" r="6"/><circle cx="12" cy="12" r="2"/></svg>
              </div>
              <div class="gc-rar-body">
                <h4>Section-wise Score Comparison</h4>
                <p>Compare performance across every paper section to identify consistent patterns.</p>
              </div>
              <span class="gc-rar-num">02</span>
            </div>
            <div class="gc-rar-item">
              <div class="gc-rar-icon gc-rar-icon-g">
                <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
              </div>
              <div class="gc-rar-body">
                <h4>Correct &amp; Incorrect Attempts</h4>
                <p>Understand error patterns question-by-question — target revision where it matters most.</p>
              </div>
              <span class="gc-rar-num">03</span>
            </div>
          </div>

          <div class="gc-rar-cta">
            <button class="gc-rar-cta-btn" routerLink="/freedemo">
              Get Your Child's RAR
              <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
            </button>
            <p class="gc-rar-cta-note">Available after every mock test session</p>
          </div>
        </div>

        <div class="gc-rar-right">
          <div class="gc-rar-img-frame">
            <img src="assets/images/ep-rar2.png" alt="Result Analysis Report"/>
            <div class="gc-rar-img-tag">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><polyline points="22 4 12 14.01 9 11.01"/></svg>
              Live Report
            </div>
          </div>
        </div>
      </div>

    </div>
  </section>


  <!-- ══════════════════════════════════════════════════════════════
       CTA BOTTOM
  ══════════════════════════════════════════════════════════════ -->
  <section class="gc-cta-section gc-reveal">
    <div class="gc-container">
      <div class="gc-cta-inner">
        <div class="gc-cta-text">
          <h2>Start Your GCSE Journey<br/><em>with Sehyog Today</em></h2>
          <p>Join thousands of students who have achieved their target grades with Sehyog Academy's expert tutors.</p>
        </div>
        <div class="gc-cta-actions">
          <button class="gc-btn-primary gc-btn-lg" (click)="bookFreeDemo()">
            Book a Free Demo
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>
          </button>
          <button class="gc-btn-outline-light" routerLink="/gcse-mock-test">Browse Mock Tests</button>
        </div>
      </div>
    </div>
  </section>

</div>